import React from 'react';

const TimeDisplay = ({ lastUpdated = "24 hours" }) => {
  return (
    <div className="flex items-center text-sm text-gray-500">
      <span>Last: {lastUpdated}</span>
      <div className="ml-2 flex items-center">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 3V8L11 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      </div>
    </div>
  );
};

export default TimeDisplay;
